type QuoteBoostBandProps = {
  callHref: string;
  callNumber: string;
  onBook: () => void;
  ariaLabel?: string;
  buttonClassName?: string;
  className?: string;
  freeTextStrong?: boolean;
  phoneNumberStrong?: boolean;
};

export function QuoteBoostBand({
  callHref,
  callNumber,
  onBook,
  ariaLabel = "Maximise your annuity payout",
  buttonClassName = "ux2-text-button",
  className = "pa-v1-results-boost",
  freeTextStrong = true,
  phoneNumberStrong = false,
}: QuoteBoostBandProps) {
  return (
    <section className={className} aria-label={ariaLabel}>
      <div>
        <p>
          On average our pension advisers can get you <strong>more</strong> annuity income than your current provider
        </p>
        <span>It's {freeTextStrong ? <strong>FREE</strong> : "FREE"} and there's no obligation!</span>
      </div>
      <div>
        <button type="button" className={buttonClassName} onClick={onBook}>MAXIMISE YOUR PAYOUT</button>
        <span>Or call FREE on</span>
        <a href={callHref}>{phoneNumberStrong ? <strong>{callNumber}</strong> : callNumber}</a>
      </div>
    </section>
  );
}
